import { Product } from '../types';

export const products: Product[] = [
  {
    id: 'shirt-1',
    title: 'Classic Tee',
    description: 'Soft cotton tee in classic fit.',
    priceCents: 1999,
    imageUrl: 'https://images.unsplash.com/photo-1512436991641-6745cdb1723f?w=800',
  },
  {
    id: 'shirt-2',
    title: 'V-Neck Shirt',
    description: 'Lightweight v-neck with breathable fabric.',
    priceCents: 2499,
    imageUrl: 'https://images.unsplash.com/photo-1576566588028-4147f3842f27?w=800',
  },
  {
    id: 'shirt-3',
    title: 'Henley Long Sleeve',
    description: 'Cozy henley with premium knit.',
    priceCents: 2999,
    imageUrl: 'https://images.unsplash.com/photo-1523205771623-e0faa4d2813d?w=800',
  },
  {
    id: 'shirt-4',
    title: 'Athletic Dry-Fit',
    description: 'Moisture-wicking performance shirt.',
    priceCents: 2799,
    imageUrl: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=800',
  },
];

export const formatPrice = (priceCents: number): string =>
  `$${(priceCents / 100).toFixed(2)}`;
